import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NotFound from "./components/NotFound";
import { PublicRoutes, PrivateRoutes } from "./routes/LazyRoutes";
import { PublicRoute } from "./middlewares/PublicRoute";
import { useSelector, useDispatch } from "react-redux";
import { receive } from "./Redux/notificationSlice";
import { PrivateRoute } from "./middlewares/PrivateRoute";
import { setAutoValue } from "./Redux/themeSlice";
import { useTheme } from "@mui/material";
import "./App.css";

function App() {
  ///////////////////////////////////////////////////////////////////////////////////
  //code to get background notification messages from service worker to react app
  const dispatch = useDispatch();
  const theme = useTheme();
  const mode = useSelector((state) => state.themeValues.originalMode);

  if ("serviceWorker" in navigator) {
    try {
      window.addEventListener("load", () => {
        navigator.serviceWorker
          .register("/firebase-messaging-sw.js")
          .then(() => {
            return navigator.serviceWorker.ready;
          });
      });
      navigator.serviceWorker.addEventListener("message", (event) => {
        if (event.data?.data?.data) {
          const msg = event.data.data.data;
          dispatch(
            receive({
              messages: [
                {
                  body: msg.body,
                  title: msg.title,
                  notificationId: msg.notificationId,
                  date: new Date().toISOString(),
                  isRead: false,
                  msgType: msg.msgType,
                  ...(msg.type && msg.id && { type: msg.type, id: msg.id }),
                },
              ],
            })
          );
        }
      });
    } catch (error) {
      console.error(error);
    }
  }
  /////////////////////////////////////////////////////////////////////////////////////
  // code to get changes in os color mode
  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

    const handleChange = (e) => {
      if (e.matches) {
        dispatch(setAutoValue({ autoValue: "dark" }));
      } else {
        dispatch(setAutoValue({ autoValue: "light" }));
      }
    };

    if (mediaQuery.matches) {
      dispatch(setAutoValue({ autoValue: "dark" }));
    } else {
      dispatch(setAutoValue({ autoValue: "light" }));
    }

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener("change", handleChange);
    } else if (mediaQuery.addListener) {
      mediaQuery.addListener(handleChange);
    }
    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener("change", handleChange);
      } else if (mediaQuery.removeListener) {
        mediaQuery.removeListener(handleChange);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  /////////////////////////////////////////////////////////////////////////////////////

  return (
    <div>
      <ToastContainer
        theme={`${mode}`}
        style={{
          direction: theme.direction,
          textAlign: theme.direction === "rtl" ? "right" : "left",
        }}
        toastClassName={theme.direction === "rtl" ? "toast-rtl" : ""}
        bodyClassName={theme.direction === "rtl" ? "toast-body-rtl" : ""}
        className={theme.direction === "rtl" ? "toast-container-rtl" : ""}
        position={theme.direction === "rtl" ? "top-left" : "top-right"}
        limit={3}
        progressStyle={{}}
      />
      <BrowserRouter>
        <Routes>
          {PublicRoutes.map((route) => (
            <Route key={route.path} path={route.path} element={<PublicRoute>{route.element}</PublicRoute>} />
          ))}
          {PrivateRoutes.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={<PrivateRoute children={route.element} />}
            />
          ))}
          <Route
            path="*"
            element={<NotFound title="Page not found - City Center App" />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
